module.exports = __webpack_public_path__ + "img/2.d91f8f22.png";